import { useEffect, useState } from "react";
import * as EmailValidator from "email-validator";
import { TextField, Button, Stack, Chip, Typography, Box } from "@mui/material";

const EditableEmailTagsField = ({
  initialEmails = [],
  maxEmails = 5,
  onSave,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [emails, setEmails] = useState(initialEmails);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleAddEmail = () => {
    if (!EmailValidator.validate(email)) {
      setError("Formato de correo inválido");
      return;
    }

    if (emails.includes(email)) {
      setError("Email ya ha sido agregado");
      return;
    }

    if (emails.length > maxEmails) {
      setError(`No puedes agregar mas de ${maxEmails} correos`);
    }

    setEmails([...emails, email]);
    setEmail("");
    setError("");
  };

  const handleDeleteEmail = (emailToDelete) => {
    setEmails(emails.filter((email) => email !== emailToDelete));
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      await onSave(emails);
      setIsEditing(false);
    } catch (error) {
      console.error(`No se pudieron guardar los cambios: ${error}`);
      setError("No se pudieron guardar los cambios");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setEmails(initialEmails);
    setIsEditing(false);
    setError("");
    setEmail("");
  };

  useEffect(() => {
    setEmails(initialEmails);
  }, [initialEmails]);

  return (
    <>
      {isEditing ? (
        <>
          <Stack spacing={1}>
            <Stack direction="row" spacing={1} flexWrap="wrap">
              {emails.map((email) => (
                <Chip
                  key={email}
                  label={email}
                  onDelete={() => handleDeleteEmail(email)}
                />
              ))}
            </Stack>
            <Stack direction="row" spacing={1} alignItems="flex-start">
              <TextField
                label="Nuevo correo"
                size="small"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleAddEmail()}
                error={!!error}
                helperText={error}
                disabled={loading}
              />
              <Button
                size="small"
                variant="outlined"
                onClick={handleAddEmail}
                disabled={loading}
                sx={{ marginTop: '30px !important'}}
              >
                Agregar
              </Button>
            </Stack>
            <Stack direction="row" spacing={1}>
              <Button
                size="small"
                variant="contained"
                onClick={handleSave}
                disabled={loading}
              >
                {loading ? "..." : "Guardar"}
              </Button>
              <Button
                size="small"
                variant="text"
                onClick={handleCancel}
                disabled={loading}
              >
                Cancelar
              </Button>
            </Stack>
          </Stack>
        </>
      ) : (
        <>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            flexWrap="wrap"
          >
            {emails.length > 0 ? (
              emails.map((email) => (
                <Chip key={email} label={email} size="small" />
              ))
            ) : (
              <Typography variant="body2" color="text.secondary">
                No hay correos operativos.
              </Typography>
            )}
            <Button size="small" onClick={() => setIsEditing(true)}>
              editar
            </Button>
          </Stack>
        </>
      )}
    </>
  );
};

export default EditableEmailTagsField;
